import createTableStore from "ds/components/Table/store/useTableStore";

import {
  AWS_USED_BY_AUTOATTACHED_TABLE_STORAGE_KEY,
  AWS_USED_BY_MANUAL_TABLE_STORAGE_KEY,
  USED_BY_COLUMN_CONFIG,
} from "./constants";

export const useIntegrationsAwsUsedByManualTableStore = createTableStore({
  storageKey: AWS_USED_BY_MANUAL_TABLE_STORAGE_KEY,
  config: USED_BY_COLUMN_CONFIG,
  version: 2,
});

export const useIntegrationsAwsUsedByAutoattachedTableStore = createTableStore({
  storageKey: AWS_USED_BY_AUTOATTACHED_TABLE_STORAGE_KEY,
  config: USED_BY_COLUMN_CONFIG,
  version: 2,
});
